export enum FileEditorScope {
  Global = 'global',
  Master = 'document.master',
}
